import React from "react";
import Button from "@material-ui/core/Button";
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import image1 from 'assets/img/slovenie.jpg'

export default class AboutSection extends React.Component {
  render() {
    return (
      <GridContainer justify="center" spacing={6} className="padding-fix">
        <GridItem xs={12} md={6} className="about-image">
          <img src={image1} />
        </GridItem>
        <GridItem xs={12} md={6} className="about">
          <h2 className="title">About</h2>
          <p>Hi there! My name is Izziël Latour. I am a 21-year-old freelance photographer/videographer who loves to travel. I'm currently living in The Hague, the Netherlands and I'm studying economics, governance and management. But whenever I get the chance to cross the border, I do!</p>
          <p>Creating content for clients is what I love! My photography helps companies and clients communicate better. My images help people to tell their stories in magazines, newsletter, social media and presentations! Some clients that I am currently working together with are: Delft University of Technology and the ABN AMRO bank.</p>
          <p>I am keen on working together with new people, so don’t hesitate to contact me!</p>
          <div class="contact-container">
            <h3 className="title">Contact</h3>
            <ul>
              <li>mail@izziel.nl</li>
              <li>+316 47588135</li>
              <li>The Hague, The Netherlands</li>
            </ul>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}